<template>
  <nav aria-label="Main" role="navigation">
    <ul class="navigation-menu flex align-center">
      <li v-for="(item, index) in headerMenu" :key="item._uid">
        <StoryblokComponent :blok="item" :index="index" />
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
const { navigationMenu } = useConfigStore()
const headerMenu = computed(() => navigationMenu?.header)
</script>

<style lang="less">
nav {
  ul.navigation-menu {
    .list-reset();
    .flex-col();
    .align-start();

    width: 100%;
    height: 100%;
    overflow-y: scroll;
    padding: 0 @gutter @gutter-lg;

    @media @wide {
      .flex-row();
      .align-center();

      width: auto;
      margin-top: 0;
      overflow: visible;
      padding: 0;
    }

    > li {
      .block();

      width: 100%;

      @media @wide {
        width: auto;
      }

      &:not(:last-child) {
        border-bottom: @2px solid @color-border;

        @media @wide {
          border-bottom: 0;
        }
      }

      > div {
        > .nav-trigger {
          .hidden();

          @media @wide {
            .block();
            .fixed();

            top: 0;
            left: 0;
            width: 100%;
            height: 100vh;
            z-index: 9;
          }
        }

        > a {
          .font-headings();
          .font-medium();
          .font-lg();
          .block();
          .relative();
          .whitespace-nowrap();

          z-index: 10;
          padding: @gutter 0 @gutter @gutter-xl;
          transition: background-color 0.2s ease-in-out 0.1s;

          @media @tablet {
            padding: @20px @gutter-sm @20px @gutter-xl;
          }

          @media @wide {
            .font-md();

            &::after {
              .absolute();

              bottom: @gutter-sm;
              left: @15px;
              right: @15px;
              border-bottom: @2px solid transparent;
              content: '';
              transition: border-color 0.8s ease-out;
              padding: @20px @gutter-sm;
            }

            &.active,
            &:focus {
              background-color: @color-fill-alternate;

              .icon {
                .text-body();
              }
            }
          }

          @media @wide {
            padding: @20px @15px;
          }

          .icon {
            .inline-block();
            .absolute();

            left: 0;
            top: 50%;
            transform: translate(0, -50%);

            @media @wide {
              .static();

              top: auto;
              left: auto;
              transform: none;
            }
          }

          &:link,
          &:visited,
          &:hover,
          &:active {
            color: @color-text;
          }

          &:hover {
            .icon {
              .text-body();
            }
          }

          &.router-link-exact-active {
            @media @wide {
              &::after {
                border-color: @color-primary;
              }

              &:hover {
                &::after {
                  border-color: @color-primary;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
